export default __webpack_public_path__ + "static/media/russia.17108585.svg";